import axios from 'axios';
import { auth } from './auth';
import logger from './logger';

const request = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
request.interceptors.request.use(
  (config) => {
    const token = auth.getToken();
    logger.log('Request interceptor - URL:', config.url, 'Token:', token ? 'Present' : 'Missing');
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Handle 401/403 responses globally
request.interceptors.response.use(
  (response) => {
    logger.log('API Response:', response.config.url, response.status, response.data);
    return response;
  },
  (error) => {
    logger.error('API Error:', error.config?.url, error.response?.status, error.response?.data);
    const status = error.response?.status;
    
    // Don't clear auth on login endpoint failures (let the saga handle it)
    const isLoginEndpoint = error.config?.url?.includes('/login');
    
    if ((status === 401 || status === 403) && !isLoginEndpoint) {
      logger.warn('Received 401/403 - clearing auth and redirecting to signin');
      auth.clear();
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  },
);

export default request;
